import React from "react";
import {connect} from "react-redux";

import COLOR_THEMES from "../../../colorThemes";


const ExclamationMarkIcon = (props) => {

  const {activeTheme} = props;

  return (
    <svg width="68px" height="59px" viewBox="0 0 68 59" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="icon-warning" stroke="none" strokeWidth="1" fill={props.color || COLOR_THEMES[activeTheme].primary} fillRule="evenodd">
        <path id="Shape-Copy" fillRule="nonzero" d="M45.031221,6.15 C39.731221,-2.05 27.731221,-2.05 22.431221,6.15 L2.13122101,37.85 C-3.56877899,46.75 2.83122101,58.55 13.431221,58.55 L54.331221,58.55 C64.931221,58.55 71.331221,46.85 65.631221,37.85 L45.031221,6.15 Z M36.931221,18.55 L35.931221,38.65 L32.531221,38.65 L31.531221,18.55 L36.931221,18.55 Z M36.331221,47.25 C35.831221,47.75 35.131221,48.05 34.231221,48.05 C33.331221,48.05 32.531221,47.75 32.031221,47.25 C31.531221,46.75 31.231221,45.95 31.231221,44.95 C31.231221,43.95 31.531221,43.25 32.031221,42.75 C32.531221,42.25 33.231221,41.95 34.231221,41.95 C35.131221,41.95 35.931221,42.25 36.431221,42.75 C36.931221,43.25 37.231221,44.05 37.231221,44.95 C37.131221,45.95 36.831221,46.65 36.331221,47.25 Z"/>
      </g>
    </svg>
  )
}

const mapStateToProps = store => {
  const {activeTheme} = store.serverState;
  return {
    activeTheme
  }
};

export default connect(mapStateToProps)(ExclamationMarkIcon)
